import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class InsFooter extends React.PureComponent {
    /**
     * 渲染网页布局
     */

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const linkLen = content.nav - 1;
        const footList = content.nav;
        const linkList = footList.map((currentLink, index) => {
            if (index < linkLen) {
                return (
                    <a href={currentLink.url} target="_blank" rel="noopener noreferrer" key={index}>
                        {currentLink.title}
                    </a>
                );
            } else {
                return (
                    <a
                        href={currentLink.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={index}
                        className={styles.noBorder}>
                        {currentLink.title}
                    </a>
                );
            }
        });

        return (
            <footer>
                <div className={styles.footlink}>
                    <div className={styles.fk_l}>{linkList}</div>
                </div>
                <div className={styles.copyright}>
                    <span>{content.content.text0}</span>
                    <span>{content.content.text1}</span>
                    <span>{content.content.text2}</span>
                </div>
            </footer>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
InsFooter.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
InsFooter.defaultProps = {};

export default InsFooter;
